import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import apiRoutes from '@/lib/apiRoutes';
import httpClient from '@/lib/httpClient';
import type { ApiError } from '../types';
import type { Contract } from './types';

export const getListContractsFn = async () => {
  const response = await httpClient.get<Contract[]>(
    process.env.NEXT_PUBLIC_API_URI + apiRoutes.contract.list
  );
  return response.data;
};

export const useGetListContracts = (
  opts?: UseQueryOptions<Contract[], ApiError>
) =>
  useQuery<Contract[], ApiError>(
    [process.env.NEXT_PUBLIC_API_URI + apiRoutes.contract.list],
    () => getListContractsFn(),
    opts
  );
